import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withRouterV6(Component) {
    function ComponentWithRouterProp(props) {
        let navigate = useNavigate();
        let location = useLocation();
        let params = useParams();
        
        // Create history object for backward compatibility
        const history = {
            push: (path) => navigate(path),
            replace: (path) => window.location.href = path,
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location: location
        };
        
        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                params={params}
                history={history}
            />
        );
    }
    return ComponentWithRouterProp;
}
